export default __webpack_public_path__ + "static/media/main_course_6.f6130faf.png";